import { render } from "./AdminCreateTicket.vue?vue&type=template&id=4154a42a&scoped=true"
import script from "./AdminCreateTicket.vue?vue&type=script&lang=js"
export * from "./AdminCreateTicket.vue?vue&type=script&lang=js"

import "./AdminCreateTicket.vue?vue&type=style&index=0&id=4154a42a&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4154a42a"]])

export default __exports__